import React, { useEffect } from 'react'
import Event from './eventImg/event-28-june.webp'


const Event14 = () => {
    useEffect(() => {
        document.title = "ACRESERVE - Technical program for Technician";
      }, []);
  return (
    <>
    <div className='eventheading'>

<h1  className='text-center'>28 June 2025</h1> 
<h3 className='text-center'>ACRESERVE - Technical program for Technician</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='ACRESERVE - Technical program for Technician'/>
<button className='mb-4'><a href='https://ishraehq.in/Admin/CalenderEventMaster/Registration_new/ueRplus8LdlkY0=' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event14

